import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Button, Col, Form, Row } from 'react-bootstrap'

export default function BackToNatureSection() {
  return (
    <Row className='back-to-nature-page mx-0' id='contact-section'>
      <Col md={6} className='d-flex flex-column justify-content-center'>
        <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
          <h2 style={{ color: '#FFF', fontWeight: '800', textAlign: 'start' }}>Giving back to the Nature</h2>
        </AnimationOnScroll>
        <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
          <p align='left' style={{ color: '#FFF', fontSize: '1.2em', fontWeight: '700' }}>
            We have collaborated with the farmers in Mysore for this initiative, and plan to continue this to other parts of Southern India to re-establish the greenery.
          </p>
        </AnimationOnScroll>
      </Col>
      <AnimationOnScroll duration={2} animateIn="animate__slideInUp" className='col col-md-6 d-flex flex-column product-contact-form'>
        <div className='d-flex  w-100'>
          <Form.Control placeholder='Name' className='me-4' />
          <Form.Control placeholder='Email' />
        </div>
        <div className='d-flex mt-4 w-100'>
          <Form.Control placeholder='Phone' className='me-4' />
          <Form.Control placeholder='Company(optional)' />
        </div>
        <Form.Control as='textarea' rows={4} placeholder='Your message' className='mt-4' />
        <div className='d-flex mt-4'>
          <Button style={{ background: '#FCCD37', color: '#000', borderRadius: '0px', borderColor: '#FCCD37', fontWeight: '700' }}>
            SEND A MESSAGE
          </Button>
        </div>
      </AnimationOnScroll>
    </Row>
  )
}
